export default __webpack_public_path__ + "static/media/sexisme.2aba5294.png";